module.exports = __webpack_public_path__ + "img/clock-circle.d0f71539.png";